module.exports = __webpack_public_path__ + "static/media/subaru-impreza-fig-1.2d5c02ea.webp";